import { useAppStore, type Theme } from '@/store/app'
import { cx } from '@/lib/cx'
import layer from './SettingsLayer.module.css'
import styles from './AppearanceSection.module.css'

export function AppearanceSection() {
  const theme = useAppStore((s) => s.theme)
  const toggleTheme = useAppStore((s) => s.toggleTheme)
  const pick = (next: Theme) => {
    if (next !== theme) toggleTheme()
  }
  return (
    <section>
      <h1 className={layer.sectionTitle}>Внешний вид</h1>
      <h2 className={layer.subTitle}>Тема</h2>
      <div className={styles.themes} role="radiogroup" aria-label="Тема">
        {([
          ['dark', 'Тёмная'],
          ['light', 'Светлая'],
        ] as const).map(([id, label]) => (
          <button key={id} type="button" role="radio" aria-checked={theme === id} className={cx(styles.theme, theme === id && styles.themeActive)} onClick={() => pick(id)}>
            <span className={cx(styles.swatch, styles[id])} aria-hidden="true" />
            {label}
          </button>
        ))}
      </div>
      <p className={layer.text}>Тема сохраняется на этом устройстве. Шрифт интерфейса — Golos Text.</p>
    </section>
  )
}
